let base = 'https://smales.ikea.co.th/api/sea/smales/'

const api = (endpoint, data) => {
  if (data) {
    if (endpoint !== 'Values') {
      base = 'https://smales.ikea.co.th/api/sea/smales/'
    }
    const headers = {
      'Content-Type': 'application/json'
    }
    if (endpoint !== 'WebLogin') {
      headers.Authorization = window.localStorage.getItem('token')
    }

    if (endpoint === 'UpdateProfile') {
      headers.customRequest = 'patch'
    }

    if (endpoint.indexOf('?') >= 0) {
      const [endpointPath, endpointQueries] = endpoint.split('?')

      endpoint = endpointPath + '.php?' + endpointQueries
    } else {
      endpoint += '.php'
    }

    return window.fetch(base + endpoint, {
      method: 'post',
      headers,
      body: JSON.stringify(data)
    })
      .then(res => {
        if (!res.ok) {
          return Promise.reject(res)
        }

        if (res.status === 204) {
          return
        }

        return res.json()
      })
  } else {
    if (endpoint === 'Values') {
      base = 'https://smales.ikea.co.th/api/sea/portal/'
    } else {
      base = 'https://smales.ikea.co.th/api/sea/smales/'
    }

    if (endpoint.indexOf('?') >= 0) {
      const [endpointPath, endpointQueries] = endpoint.split('?')

      endpoint = endpointPath + '.php?' + endpointQueries
    } else {
      endpoint += '.php'
    }

    return window.fetch(base + endpoint, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': window.localStorage.getItem('token')
      }
    })
      .then(res => {
        if (!res.ok) {
          return Promise.reject(res)
        }

        return res.json()
      })
  }
}

export default api
